import React, { useState } from 'react';
import { Table } from 'antd';
import { currencyFormat } from 'helpers/service_helper';

const EngSummaryFinance = ({userInfo}) => {
const columns = [
    {
        title: 'سال',
        dataIndex: 'year',
        key: 'year',
        render: (year) => (
          <span className="h6">
            {year}
          </span>
        )
      },
    {
        title: 'مبلغ',
        dataIndex: 'amount',
        key: 'amount',
        render: (amount) => (
          <span className="h6">
            {currencyFormat(amount)}
          </span>
        )
    },

  ];

  return (
    <div>
      <Table
        dataSource={userInfo?.engPaymentReportViewModels}
        columns={columns}
        rowKey={(record) => record.year}
      />
    </div>
  );
};

export default EngSummaryFinance;
